
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AppModeGuard implements CanActivate {
    
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let rawAppInfo = sessionStorage.getItem('id');
        let statusAllowedToEdit: Array<string> = ["Submitted", "In Progress"];

        let canEdit: boolean = false;
        if (rawAppInfo) {
            let appInfo = JSON.parse(rawAppInfo);
            if ((appInfo.appStatus && appInfo.appStatus == 'Draft') ||
                (appInfo.appStatus && appInfo.appMode &&  statusAllowedToEdit.indexOf(appInfo.appStatus) >= 0 && appInfo.appMode == 'Edit')) {
                canEdit = true;
            }
        }

        return canEdit;
    }
}